import {motion} from 'framer-motion';
import Card from "../../shared/Card";
import TextInputHorizontalTag from "../../shared/TextInputHorizontalTag";
import ButtonFunction from "../../shared/ButtonFunction";
import GeneralContext from "../../../context/GeneralContext";
import { fetchBody } from '../../../utils/fetch';
import { useContext } from "react";

function ResetPoints() {

  const { changeCurrentMenu, changeModalTitle, changeModalText, changeModalType } = useContext(GeneralContext);

  const resetFunction = async () => {
    const modal = document.getElementById("myModal");
    const fetchData = {
      change: Number(document.getElementById('resetAmount').value),
      reason: document.getElementById('resetText').value,
    }
    let validFetch = true;
    if (fetchData.change === 0) {
        validFetch = false;
        alert('El cambio debe ser diferente de cero');
    }
    if (fetchData.reason.length < 11 && validFetch) {
        validFetch = false;
        alert('Por favor escriba una razón de más de 10 caracteres');
    }
    if (validFetch) {
        const response = await fetchBody('points/reset', 'POST', fetchData);
        if (response.success) {
            changeCurrentMenu('manage-points');
        } else {
            changeModalTitle('Error al intentar restablecer los puntos de los usuarios');
            changeModalText(response.reason);
            changeModalType('alert');
            modal.style.display = "block";
        }
    }
  }

  return (
    <motion.div
        id='addBenefitCard'
        key='adminAddUser'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-points'}>
            <h2>Restablecer Puntos de Todos los Usuarios</h2>
            <p style={{color: 'red'}}>Es importante tener en cuenta que este cambio afectará irreversiblemente a <strong>TODOS</strong> los usuarios del sistema, por lo que se aconseja precaución</p>
            <TextInputHorizontalTag label="Puntos finales para los usuarios" type="number" id="resetAmount" inputClass='adminInput'></TextInputHorizontalTag>
            <br />
              <label><strong>Razón de la decisión</strong></label>
              <br />
              <textarea id="resetText" className="adjustText" cols="50" rows="3"></textarea>
            <br />
            <br />
            <ButtonFunction buttonClass='adminButton' buttonFunction={resetFunction}>Restablecer Puntos</ButtonFunction>
          </Card>
    </motion.div>
  )
}

export default ResetPoints